export const module = {
  info: {
    name: 'voip-rate-division-side-menu',
    caption: 'voip rate division side menu',
    viewGroup: 'general-modules'
  },
  vuexModules: [],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Rate Division',
    icon: 'el-icon-copy-document',
    routeName: 'module->voip-rate-division->list->page',
    routeParams: { listPage: 1}
  }
}

export default module
